module.exports = __webpack_public_path__ + "img/nav-medicine-stock.fff9624a.svg";